import styled from 'styled-components';
import spacing from '../../styles/spacing';
import { scrollShadow } from '../../styles/mixins';
import { vars } from '../../theme';
import { applyOpacity } from '../../utils/color.utils';

export const Container = styled.div<{
    $isScrolledLeft: boolean;
    $isScrolledRight: boolean;
    $backgroundColor?: string;
}>`
    display: flex;
    flex-direction: column;
    height: 100%;
    flex: 1 1 0;
    min-height: 0;
    position: relative;
    ${({ $backgroundColor }) =>
        $backgroundColor ? `background-color: ${$backgroundColor};` : ''}

    ${({ $isScrolledLeft, $backgroundColor }) =>
        scrollShadow({
            isShadowActive: $isScrolledLeft,
            size: 40,
            direction: 'left',
            isInset: true,
            isFlat: true,
            flatColor: applyOpacity(
                $backgroundColor || vars.colors.surface.container,
                75
            )
        })}
    ${({ $isScrolledRight, $backgroundColor }) =>
        scrollShadow({
            isShadowActive: $isScrolledRight,
            size: 40,
            direction: 'right',
            isInset: true,
            isFlat: true,
            flatColor: applyOpacity(
                $backgroundColor || vars.colors.surface.container,
                75
            )
        })}
`;
export const BoardGroupsAndContent = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    min-height: 0;
`;

export const HorizontalPaddingWrapper = styled.div<{
    $horizontalPadding?: number;
}>`
    display: flex;
    flex-direction: row;
    height: 100%;

    ${({ $horizontalPadding }) =>
        $horizontalPadding !== undefined
            ? `
        &::before,
        &::after {
            content: '';
            display: block;
            position: relative;
            flex-shrink: 0;
            min-width: ${$horizontalPadding}px;
        }
    `
            : ''}
`;

export const ScrollContainer = styled.div`
    display: flex;
    flex-direction: column;
    overflow-x: auto;
    overflow-y: hidden;
    height: 100%;
    padding-bottom: ${spacing[12]};
`;

export const KanbanBoard = styled.div`
    display: flex;
    gap: ${spacing[8]};
    align-items: stretch;
    flex: 1;
    min-height: 0;
`;
